<template>
  <div class="col" :class="objectClass">
    <slot />
  </div>
</template>

<script>
const colsValidator = (val) => val >= 1 && val <= 12;

export default {
  props: {
    /**
     * Amount of columns
     */
    cols: {
      type: Number,
      default: undefined,
      validator: colsValidator,
    },

    /** Amount of columns in viewport 500 */
    cols500: { type: Number, default: undefined, validator: colsValidator },
    /** Amount of columns in viewport 400 */
    cols400: { type: Number, default: undefined, validator: colsValidator },
    /** Amount of columns in viewport 300 */
    cols300: { type: Number, default: undefined, validator: colsValidator },
    /** Amount of columns in viewport 200 */
    cols200: { type: Number, default: undefined, validator: colsValidator },
    /** Amount of columns in viewport 100 */
    cols100: { type: Number, default: undefined, validator: colsValidator },

    /** Moves the col the amount of columns to the right in viewport 500 */
    offset500: { type: Number, default: undefined, validator: colsValidator },
    /** Moves the col the amount of columns to the right in viewport 400 */
    offset400: { type: Number, default: undefined, validator: colsValidator },
    /** Moves the col the amount of columns to the right in viewport 300 */
    offset300: { type: Number, default: undefined, validator: colsValidator },
    /** Moves the col the amount of columns to the right in viewport 200 */
    offset200: { type: Number, default: undefined, validator: colsValidator },
    /** Moves the col the amount of columns to the right in viewport 100 */
    offset100: { type: Number, default: undefined, validator: colsValidator },
  },

  computed: {
    objectClass() {
      return [
        this.cols === undefined ? "" : `col-${this.cols}`,
        this.cols100 === undefined ? "" : `col-100-${this.cols100}`,
        this.cols200 === undefined ? "" : `col-200-${this.cols200}`,
        this.cols300 === undefined ? "" : `col-300-${this.cols300}`,
        this.cols400 === undefined ? "" : `col-400-${this.cols400}`,
        this.cols500 === undefined ? "" : `col-500-${this.cols500}`,
        this.offset100 === undefined ? "" : `offset-100-${this.offset100}`,
        this.offset200 === undefined ? "" : `offset-200-${this.offset200}`,
        this.offset300 === undefined ? "" : `offset-300-${this.offset300}`,
        this.offset400 === undefined ? "" : `offset-400-${this.offset400}`,
        this.offset500 === undefined ? "" : `offset-500-${this.offset500}`,
      ];
    },
  },
};
</script>
